import {MobCard} from "../components/MobCard";
import {DynamicIcon} from "lucide-react/dynamic";
import React from "react";
import {contactCopie, contactFormatTel, contactToCapitalize, getContactEmails, getContactTels} from "./functions";
import { Popover } from 'antd-mobile'
import {Trans} from "@lingui/react/macro";
import {t} from "@lingui/core/macro";
import {useNavigate} from "react-router-shim";
import {MOBCOLORS, MOBILE_PREFIX_PATH} from "../../configs/AppConfig";
import {useActionSheet} from "../providers/ActionSheetProvider";
import MobPressable from "../components/MobPressable";
import MobContactHeader from "./MobContactHeader";
import { Popconfirm, Tag } from 'antd';


export default function ContactMainCard({selected,embedParams}){

    const navigate=useNavigate()
    const actionSheetManager=useActionSheet()

    const beforeNavigate=()=>{
        if(embedParams?.onClose){
            embedParams.onClose()
        }
    }

    const makeCall=async ()=>{
        const tels=getContactTels(selected)
        if(tels.length===0){
            return false
        }
        if(tels.length===1){
            return window.open("tel:"+tels[0].number)
        }

        actionSheetManager.open(tels.map(i=>{
            return {
                bold:i.main,
                text:i.formatedNumber+" ("+i.title+")",
                onClick:()=>{
                    window.open("tel:"+i.number)
                }
            }
        }),(<Trans>Appeler le :</Trans>))
    }

    const makeSms=async ()=>{
        const tels=getContactTels(selected)
        if(tels.length===0){
            return false
        }
        if(tels.length===1){
            return window.open("sms:"+tels[0].number)
        }

        actionSheetManager.open(tels.map(i=>{
            return {
                bold:i.main,
                text:i.formatedNumber+" ("+i.title+")",
                onClick:()=>{
                    window.open("sms:"+i.number)
                }
            }
        }),(<Trans>Envoyer un SMS au :</Trans>))
    }

    const makeWhatsapp=async ()=>{
        const tels=getContactTels(selected)
        if(tels.length===0){
            return false
        }
        if(tels.length===1){
            return window.open("https://wa.me/"+tels[0].number)
        }

        actionSheetManager.open(tels.map(i=>{
            return {
                bold:i.main,
                text:i.formatedNumber+" ("+i.title+")",
                onClick:()=>{
                    window.open("https://wa.me/"+i.number)
                }
            }
        }),(<Trans>Envoyer un Whatsapp au :</Trans>))
    }

    const makeEmail=async ()=>{
        const emails=getContactEmails(selected)
        if(emails.length===0){
            return false
        }
        if(emails.length===1){
            return window.open("mailto:"+emails[0].email)
        }

        actionSheetManager.open(emails.map(i=>{
            return {
                bold:i.main,
                text:i.email+" ("+i.title+")",
                onClick:()=>{
                    window.open("mailto:"+i.email)
                }
            }
        }),(<Trans>Envoyer un email a :</Trans>))
    }

    return(
        <MobCard>
            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <div style={{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <MobContactHeader contact={selected}/>

                    {selected.deleted && <Tag color={"orange"} style={{marginLeft: 10}}><Trans>SUPPRIMÉ</Trans></Tag>}
                    {selected.archived &&(
                        <Popconfirm
                            title={t`Êtes-vous sûrs de vouloir déarchiver ce contact ?`}
                            onConfirm={() => selected.__onUnarchiveContact()}
                            okText={t`Oui`}
                            cancelText={t`Non`}
                            okType={"danger"}
                        >
                            <Tag color={"blue"} style={{marginLeft: 10,cursor:"pointer"}}><Trans>ARCHIVÉ</Trans></Tag>
                        </Popconfirm>
                    )}
                </div>

                <span style={{
                    textAlign:"center",
                    fontSize: 26,
                    color: MOBCOLORS.blue.color,
                    marginBottom: 15
                }}><span style={{fontWeight: "bold",}}>{selected.nom?.toUpperCase()}</span> {contactToCapitalize(selected.prenom)}</span>

                {(selected?.parents?.length===0 && (getContactEmails(selected).length>0 || getContactTels(selected).length>0)) &&(
                    <>
                        <div style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-around",
                            alignItems: "center",
                            fontSize: 12
                        }}>

                            <Popover
                                content={(<Trans>Tel. Copié</Trans>)}
                                trigger='click'
                                placement='top'
                                mode='dark'
                            >
                                <MobPressable style={{display: "flex", alignItems: "center", gap: 5, opacity: selected.tel ? 1 : 0}}
                                              onClick={() => {
                                                  if (selected.tel) {
                                                      contactCopie(selected.tel)
                                                  }
                                              }}>
                                    <span>{contactFormatTel(selected.tel)}</span>
                                    <DynamicIcon name={"copy"} color={"#000"} size={18}
                                                 style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
                                </MobPressable>
                            </Popover>

                            <Popover
                                content={(<Trans>Email Copié</Trans>)}
                                trigger='click'
                                placement='top'
                                mode='dark'
                            >
                                <MobPressable style={{display: "flex", alignItems: "center", gap: 5, opacity: selected.email ? 1 : 0}}
                                              onClick={() => {
                                                  if (selected.email) {
                                                      contactCopie(selected.email)
                                                  }
                                              }}>
                                    <span>{selected.email}</span>
                                    <DynamicIcon name={"copy"} color={"#000"} size={18}
                                                 style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
                                </MobPressable>
                            </Popover>

                        </div>

                        <div style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-around",
                            alignItems: "center",
                            marginTop: 15
                        }}>

                            <MobPressable style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "100%",
                                padding: 10,
                                backgroundColor: MOBCOLORS.green.color
                            }}
                                          onClick={() => makeCall()}
                            >
                                <DynamicIcon name={"phone"} color={"#FFF"} size={20} fill={"#FFF"} strokeWidth={0}
                                             style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
                            </MobPressable>

                            <MobPressable style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "100%",
                                padding: 10,
                                backgroundColor: MOBCOLORS.green.color
                            }}
                                          onClick={() =>makeWhatsapp()}
                            >
                                <img src={"/img/brands/whatsapp-white.png"} style={{width:23,height:23}}/>
                            </MobPressable>

                            <MobPressable style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "100%",
                                padding: 10,
                                backgroundColor: MOBCOLORS.cyan.color
                            }}
                                          onClick={() => makeSms()}
                            >
                                <DynamicIcon name={"message-circle"} color={"#FFF"} size={20} fill={"#FFF"} strokeWidth={0}
                                             style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
                            </MobPressable>

                            <MobPressable style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "100%",
                                padding: 10,
                                backgroundColor: MOBCOLORS.gray.color
                            }}
                                          onClick={() => makeEmail()}
                            >
                                <DynamicIcon name={"mail"} color={"#FFF"} size={20}  strokeWidth={3}
                                             style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
                            </MobPressable>

                        </div>
                    </>
                )}

                {selected.parents.length===0 &&(
                    <div style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 25,
                        flexWrap:"wrap",
                        gap:10
                    }}>


                        <MobPressable
                            style={{display:"flex",flex:1,justifyContent:"center",alignItems:"center",backgroundColor:MOBCOLORS.blue.color,color:"#FFF",fontSize:15,padding:"5px 10px",borderRadius:10}}
                            onClick={()=>{
                                let mobHeaderTitle=encodeURIComponent(`${selected.prenom} ${selected.nom}`)
                                let routeParam="?&searchId="+selected.id+"&contactName="+mobHeaderTitle
                                beforeNavigate()
                                navigate(MOBILE_PREFIX_PATH+"/submits/contact"+routeParam)
                            }}
                        >
                            <span><Trans>Inscriptions</Trans></span>
                        </MobPressable>

                        <MobPressable
                            style={{display:"flex",flex:1,justifyContent:"center",alignItems:"center",backgroundColor:MOBCOLORS.blue.color,color:"#FFF",fontSize:15,padding:"5px 10px",borderRadius:10}}
                            onClick={()=>{
                                let mobHeaderTitle=encodeURIComponent(`${selected.prenom} ${selected.nom}`)
                                let routeParam="?&searchId="+selected.id+"&contactName="+mobHeaderTitle
                                beforeNavigate()
                                navigate(MOBILE_PREFIX_PATH+"/promesses/list"+routeParam)
                            }}
                        >
                            <span><Trans>Promesses</Trans></span>
                        </MobPressable>

                        <MobPressable
                            style={{display:"flex",flex:1,justifyContent:"center",alignItems:"center",backgroundColor:MOBCOLORS.blue.color,color:"#FFF",fontSize:15,padding:"5px 10px",borderRadius:10}}
                            onClick={()=>{
                                let mobHeaderTitle=encodeURIComponent(`${selected.prenom} ${selected.nom}`)
                                let routeParam="?&searchId="+selected.id+"&contactName="+mobHeaderTitle
                                beforeNavigate()
                                navigate(MOBILE_PREFIX_PATH+"/abonnements/list"+routeParam)
                            }}
                        >
                            <span><Trans>Abonnements</Trans></span>
                        </MobPressable>

                        <MobPressable
                            style={{display:"flex",flex:1,justifyContent:"center",alignItems:"center",backgroundColor:MOBCOLORS.blue.color,color:"#FFF",fontSize:15,padding:"5px 10px",borderRadius:10}}
                            onClick={()=>{
                                let mobHeaderTitle=encodeURIComponent(`${selected.prenom} ${selected.nom}`)
                                let routeParam="?&searchId="+selected.id+"&contactName="+mobHeaderTitle
                                beforeNavigate()
                                navigate(MOBILE_PREFIX_PATH+"/paiements/list"+routeParam)
                            }}
                        >
                            <span><Trans>Paiements</Trans></span>
                        </MobPressable>

                    </div>
                )}

            </div>
        </MobCard>
    )
}
